import { useState } from 'react';

import { ErrorReporter } from '@/infra/monitoring/error-reporter';
import { Services } from '@/infra/services';
import {
  type FeedbackType,
  type FeedbackVoteValue,
  type ReviewId,
  type GoodFeedbackAmount,
  type BadFeedbackAmount,
} from '@/infra/services/catalog/review/model';

interface UseActionsProps {
  initialGoodFeedbackAmount: GoodFeedbackAmount;
  initialBadFeedbackAmount: BadFeedbackAmount;
  reviewId: ReviewId;
}

export const useActions = (props: UseActionsProps) => {
  const { reviewId, initialGoodFeedbackAmount, initialBadFeedbackAmount } =
    props;

  const [badFeedbackAmount, setBadFeedbackAmount] = useState(
    initialBadFeedbackAmount
  );

  const [goodFeedbackAmount, setGoodFeedbackAmount] = useState(
    initialGoodFeedbackAmount
  );

  const [isHelpfulClicked, setIsHelpfulClicked] = useState(false);
  const [isInappropriateClicked, setIsInappropriateClicked] = useState(false);

  const sendGoodFeedBack = () => {
    postFeedback('helpfulness', 'positive');

    setIsHelpfulClicked(true);
    setGoodFeedbackAmount((prev) => prev + 1);
  };

  const sendBadFeedBack = () => {
    postFeedback('helpfulness', 'negative');

    setIsHelpfulClicked(true);
    setBadFeedbackAmount((prev) => prev + 1);
  };

  const sendInappropriateFeedBack = () => {
    postFeedback('inappropriate');

    setIsInappropriateClicked(true);
  };

  const postFeedback = async (
    feedbackType: FeedbackType,
    voteValue?: FeedbackVoteValue
  ) => {
    try {
      await Services.Catalog.Review.postFeedback({
        feedbackType,
        voteValue,
        reviewId,
      });
    } catch (error) {
      ErrorReporter.report({ error, level: 'error' });
    }
  };

  return {
    badFeedbackAmount,
    goodFeedbackAmount,
    isHelpfulClicked,
    isInappropriateClicked,
    sendGoodFeedBack,
    sendBadFeedBack,
    sendInappropriateFeedBack,
  };
};
